import React, { useState, useEffect } from "react";

import { Row, Col, FormGroup, Button, Label } from "reactstrap";

import ControldocDataTable from "../../../controldoc/datatable";

const BulkRequestDestroyDocumentTable = props => {
  const {
    bulkRequest,
    setBulkRequest,
    dataTableConfiguration: {
      columns: dataTableColumns
    },
    configuration: {
      context,
      defaultRequestParams,
      showDistributionListFilter,
    },
    routes: {
      indexDocumentsPath,
      indexBulkRequestPath,
      showBulkRequestPath,
    },
    services: {
      createService,
    }
  } = props;

  const [disabledSubmitButton, setDisabledSubmitButton] = useState(false)

  const formName = 'bulk_request_destroy_document';

  const handleConfirmSubmit = () => {
    swalWithBootstrap
      .fire({
        title: I18n.t(
          "laboral.bulk.request.destroy_documents.form.confirm.title"
        ),
        html: I18n.t(
          "laboral.bulk.request.destroy_documents.form.confirm.message"
        ),
      })
      .then(result => {
        if (result.isConfirmed) {
          handleSubmit();
        }
      });
  };

  const drawTextSubmitButton = () => {
    if (disabledSubmitButton) {
      return "Guardando información ...";
    } else {
      return I18n.t("actions.save");
    }
  };

  const drawSubmitButton = () => {
    return (
      <Button
        color="success"
        className="ml-2"
        onClick={handleConfirmSubmit}
        disabled={disabledSubmitButton}
      >
        {drawTextSubmitButton()}
      </Button>
    );
  };

  const handleSubmit = () => {
    let formData = getFormData();
    setDisabledSubmitButton(true);

    createService(formData, response => {
      if (response.status == 201) {
        window.location = showBulkRequestPath(response.data.id);
      } else if (response.status == 422) {
        setBulkRequest(response.data);
        setDisabledSubmitButton(false);
      }
    });
  };

  const getFormData = () => {
    let _formData = new FormData();
    _.each(bulkRequest.items, function (item, _index) {
      _formData.append(`${formName}[items_attributes][${_index}][document_id]`, item.id || "");
    });

    return _formData;
  }

  const drawItemsErrors = () => {
    if (_.has(bulkRequest, 'errors.items')) {
      return (
        <div className="alert alert-danger">
          {_.map(bulkRequest.errors.items, function (error, index) {
            return <span key={`item-error-${index}`}>{error}</span>
          })}
        </div>
      )
    }
  }

  const onSelectionChange = selectedRecords => {
    setBulkRequest(prevState => {
      return {
        ...prevState,
        ['items']: selectedRecords
      }
    })
  }

  return (
    <Row>
      <Col md="12">
        <Label className="d-flex justify-content-center h5 my-4">Lista de documentos</Label>
        {drawItemsErrors()}
        <ControldocDataTable
          columns={dataTableColumns}
          configuration={{
            showDistributionListFilter: showDistributionListFilter,
            showGridlines: true,
            context: context,
            fetchRecords: {
              endpoint: indexDocumentsPath,
              keyName: "documents",
              defaultRequestParams: defaultRequestParams
            },
            selectable: {
              enabled: true,
              mode: 'multiple',
              selection: bulkRequest['items'],
              onSelectionChange: onSelectionChange
            }
          }}
        />
      </Col>
      <FormGroup className="text-end mt-5">
        <a
          href={indexBulkRequestPath()}
          className="btn btn-default"
        >
          {I18n.t("actions.back")}
        </a>
        {drawSubmitButton()}
      </FormGroup>
    </Row>
  )
}

export default BulkRequestDestroyDocumentTable;
